// mutations
const ACADEMIC_STUDENTS_ALL = (state, academicStudents) => {
    if (academicStudents.code === 1) {
      state.academicStudents = academicStudents.data
      state.status = 'success'
    } else {
      alert(academicStudents.message)
      state.academicStudents = academicStudents
      state.status = 'error'
    }
  }
  
  export default {
    ACADEMIC_STUDENTS_ALL
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/academic/student/mutations.js